import { useParams } from 'react-router-dom';

import { ProjectShell } from '@/project-management/components/layout/project-shell';
import { Workstream } from '@/project-management/pages/workstreams/components/workstream';
import { WorkstreamsQuery } from '@/project-management/queries/workstreams.query';

import { AddWorkstreamButton } from './components/add-workstream-button';
import { WorkstreamsEmpty } from './workstreams.empty';
import { WorkstreamsLoading } from './workstreams.loading';

export function WorkstreamsPage() {
  const { siteId } = useParams<{ siteId: string }>();
  const workstreamsQuery = WorkstreamsQuery.useQuery({ siteId });

  if (workstreamsQuery.isLoading) {
    return <WorkstreamsLoading />;
  }

  if (workstreamsQuery.isError || !workstreamsQuery.data) {
    throw workstreamsQuery.error;
  }

  const { workstreams } = workstreamsQuery.data;

  return (
    <ProjectShell testId="project-management-workstreams">
      <div className="space-y-4">
        {workstreams.length === 0 ? (
          <WorkstreamsEmpty />
        ) : (
          <>
            <div className="flex items-baseline justify-between">
              <h2 className="font-condensed text-xl font-bold text-gray-900">
                Project Workstreams
              </h2>
              <AddWorkstreamButton />
            </div>

            <div className="space-y-6">
              {workstreams.map((workstream) => (
                <Workstream key={workstream.id} workstream={workstream} />
              ))}
            </div>
          </>
        )}
      </div>
    </ProjectShell>
  );
}

export default WorkstreamsPage;
